
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/marigold-engage",
      function () {
        return require("private-next-pages/destinations/marigold-engage.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/marigold-engage"])
      });
    }
  